export enum EReturnReasons {
  NONE = '',
  ITEM_DAMAGED = 'ITEM_DAMAGED',
  DOES_NOT_MEET_EXPECTATIONS = 'ITEM_DOES_NOT_MEET_EXPECTATIONS',
  ITEM_DID_NOT_FIT = 'ITEM_DID_NOT_FIT',
  WRONG_ITEM = 'WRONG_ITEM',
}
